import { apiAddressLookup } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';

export const typePrefix = 'address-lookup';

const config = [
  { actionType: 'getAddress', apiPath: `${apiAddressLookup}/addressLookup`, method: get },
  { actionType: 'getDetails', apiPath: `${apiAddressLookup}/addressDetails`, method: get },
];

export const { getAddress, getDetails } = createThunks(typePrefix, config);
